import * as React from 'react'
import { Switch } from '$views/components/Switch'
import { ModalWindow } from '$views/components/ModalWindow'
import { Block, Button } from '$views/components'
import { Text } from '$views/components/Text'

interface Props {
  handleSettingsCookies: () => void
  preferenceCookies: boolean
  setPreferencesCookies: () => void
  statisticsCookies: boolean
  setStatisticsCookies: () => void
  onSubmit: () => void
}

export const CookieSettingsModal: React.SFC<Props> = ({
  handleSettingsCookies,
  preferenceCookies,
  setPreferencesCookies,
  statisticsCookies,
  setStatisticsCookies,
  onSubmit,
}) => {
  return (
    <ModalWindow onClose={handleSettingsCookies} cookies>
      <Text header>Configurar cookies</Text>
      <Text marginTop="mini">
        A continuación, le ofrecemos la posibilidad de configurar las cookies de nuestra web.
      </Text>
      <Block flex marginTop="small">
        <Switch isChecked={() => true} disabled block />
        <Block marginLeft="mini">
          <Text weight="medium" as="span">
            Cookies Necesarias:{' '}
          </Text>
          <Text as="span">
            Siempre activas. Ayudan a hacer una página web utilizable activando funciones básicas como la navegación en
            la página y el acceso a áreas seguras de la página web. La página web no puede funcionar adecuadamente sin
            estas cookies. Son imprescindibles para el correcto funcionamiento del sitio web.
          </Text>
        </Block>
      </Block>
      <Block flex marginTop="small">
        <Switch isChecked={() => preferenceCookies} onClick={setPreferencesCookies} />
        <Block marginLeft="mini">
          <Text weight="medium" as="span">
            Cookies de Preferencia:{' '}
          </Text>
          <Text as="span">
            Permiten a la página web recordar toda aquella información que cambia la forma en que la página se comporta
            o el aspecto que tiene, como el idioma preferido o la región.
          </Text>
        </Block>
      </Block>
      <Block flex marginTop="small" marginBottom="medium">
        <Switch isChecked={() => statisticsCookies} onClick={setStatisticsCookies} />
        <Block marginLeft="mini">
          <Text weight="medium" as="span">
            Cookies Estadísticas:{' '}
          </Text>
          <Text as="span">
            Ayudan a los propietarios de páginas web a comprender cómo interactúan los visitantes con las páginas web
            reuniendo y proporcionando información de forma anónima.
          </Text>
        </Block>
      </Block>
      <Block marginBottom="mini">
        <Button secondary onClick={onSubmit}>
          Guardar
        </Button>
      </Block>
    </ModalWindow>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/CookieBanner/components/CookieSettingsModal.tsx